import { provideStates } from '@ngxs/store';

import { CustomerPortalCollectionAuthState } from './lib/states/auth.state';

export { CustomerPortalCollectionAuthActions } from './lib/actions';
export { CustomerPortalCollectionAuthQueries } from './lib/queries';
export { SednaAuthService } from './lib/services';
export {
  customerPortalCollectionAccessGuard,
  customerPortalProductAccessGuard,
} from './lib/guards';
export {
  getCustomerPortalCollectionAuthDataFromLocalStorage,
  getCustomerPortalProductAuthDataFromLocalStorage,
  removeAuthDataForCollectionId,
  removeAuthDataForProductId,
  setCustomPortalCollectionAuthDataToLocalStorage,
  setCustomPortalProductAuthDataToLocalStorage,
} from './lib/utils/local-storage-auth-data';
export type {
  CustomerPortalCollectionAuthStoragePayload,
  CustomerPortalCollectionStorageAuthDataItem,
} from './lib/utils/local-storage-auth-data';
export {
  provideRetainCollectionAccessCodeLinkConfig,
  retainCollectionAccessCodeIfNeeded,
} from './lib/utils/retain-access-code.util';

export function provideCustomerPortalCollectionAuthDataAccess() {
  return provideStates([CustomerPortalCollectionAuthState]);
}

export { CUSTOMER_PORTAL_COLLECTION_AUTH_STATE_TOKEN } from './lib/states/auth.state';
